import ARTICLE from "./article"

export { ARTICLE }
export const API_URL = "/api/" // https://sonar-project.cf/api/"
